import { StoreAction, XmAction } from 'store/actions';
import { StepUpAuthLineLock } from './models/step-up-line-lock';
import { StepUpAuthPortOut } from './models/step-up-port-out';
import { StepUpAuthPaymentInstrument } from './models/step-up-payment-instrument';

export function stepUpAuthLinkLockReducer(state: StepUpAuthLineLock, action: XmAction<StepUpAuthLineLock>): StepUpAuthLineLock {
    switch (action.type) {
        case StoreAction.STEP_UP_LINE_LOCK:
            return action.payload;
        default:
            return state;
    }
}

export function stepUpAuthPortOutReducer(state: StepUpAuthPortOut, action: XmAction<StepUpAuthPortOut>): StepUpAuthPortOut {
    switch (action.type) {
        case StoreAction.STEP_UP_PORT_OUT:
            return action.payload;
        default:
            return state;
    }
}

export function stepUpAuthPaymentInstrumentReducer(state: StepUpAuthPaymentInstrument, action: XmAction<StepUpAuthPaymentInstrument>): StepUpAuthPaymentInstrument {
    switch (action.type) {
        case StoreAction.STEP_UP_ADD_INSTRUMENT:
            return action.payload;
        default:
            return state;
    }
}

